import { useAtomValue } from 'jotai';
import { useNumFormatter } from '~/utils/format/num-formatter';
import { useTranslation } from 'react-i18next';
import { $CurrentAvailableHashtagInfoOrNull } from '~/routes/topic.$hashtag_id/shared/atoms';

export const useHashtagDesc = (): string => {
  const { t } = useTranslation();
  const formatNum = useNumFormatter();
  const hashtag = useAtomValue($CurrentAvailableHashtagInfoOrNull);

  if (!hashtag) {
    return '';
  }

  const { views_count, description } = hashtag;
  const viewsCount = formatNum(views_count);
  const viewsCountDesc = t('view_count_plural', { num: viewsCount }).replace('%d', viewsCount);

  return `${viewsCountDesc}, ${description.trim()}`;
};
